import React from 'react';

import {
  useLoadConversionPage,
  useUpdateConversionPage,
  useIsUpdating,
} from 'scenes/Gallery/ConversionPages/ConversionPages/data';

import ConversionPageForm from './ConversionPageForm';

const ConversionPageFormEdit = ({ id, onSubmit, onClose, open, onExited }) => {
  const { data, isLoading } = useLoadConversionPage({ id });
  const [updateConversionPage] = useUpdateConversionPage();
  const isUpdating = useIsUpdating();

  const handleSubmit = async (values) => {
    await updateConversionPage(values);
    onSubmit();
  };

  return (
    <ConversionPageForm
      loading={isLoading || isUpdating}
      onClose={onClose}
      open={open}
      onExited={onExited}
      subTitle={data?.name}
      initialValues={data}
      onSubmit={handleSubmit}
      entityId={id}
    />
  );
};

export default ConversionPageFormEdit;
